import PaymentResultComponent from '../components/payment-result/payment-result'

const Payment = () => <PaymentResultComponent />

export default Payment;